module.exports = __webpack_public_path__ + "static/media/1.bf40b0e8.jpg";